import { match, P } from 'ts-pattern'
import { useEntity } from '@backstage/plugin-catalog-react'
import { Card, CardHeader, CardBody, Text } from '@backstage/ui'
import WorkIcon from '@material-ui/icons/Work'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import PeopleIcon from '@material-ui/icons/People'
import { List, ListItem, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core'
import { UserEntity } from '@backstage/catalog-model'

type EnrichedUserProfile = UserEntity['spec']['profile'] & {
  jobTitle?: string
  country?: string
  city?: string
}

export default function EntityUserProfileExtraCard() {
  const { entity } = useEntity()
  const profile = entity?.spec?.profile as EnrichedUserProfile | undefined
  const jobTitle = profile?.jobTitle ?? '(Missing job title)'

  const location = match([profile?.city, profile?.country])
    .with([P.string, P.string], ([city, country]) => `${city}, ${country}`)
    .with([P._, P.string], ([_, country]) => `${country}`)
    .with([P.string, P._], ([city, _]) => `${city}`)
    .otherwise(() => '(Missing location)')

  const teamName = match(entity.metadata.annotations?.['sennder.com/okta-team-name'])
    .with(P.string, teamName => teamName)
    .otherwise(() => '(Not set)')

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader>
        <Text variant="title-x-small" weight="bold">
          Additional Information
        </Text>
      </CardHeader>
      <CardBody>
        <List>
          <ListItem>
            <ListItemIcon>
              <Tooltip title={'Job title'}>
                <WorkIcon />
              </Tooltip>
            </ListItemIcon>
            <ListItemText>{jobTitle || '(Missing job title)'}</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Tooltip title={'Location'}>
                <LocationOnIcon />
              </Tooltip>
            </ListItemIcon>
            <ListItemText>{location}</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Tooltip title={'Team name in Okta and HR system'}>
                <PeopleIcon />
              </Tooltip>
            </ListItemIcon>
            <ListItemText>{teamName}</ListItemText>
          </ListItem>
        </List>
      </CardBody>
    </Card>
  )
}
